import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Form as FinalForm } from 'react-final-form';
import { DataLayer } from '@alfa-bank/site-data-layer';
import { getPlatformID as platformId } from '@alfa-bank/site-helpers-common/browser/get-platform-id';

import { Form as Component } from '../form';
import type { TDesktop, IDeps } from '../models';

import styles from './desktop.css';

export const FormDesktop = createWidget<IDeps, TDesktop>({
    DataLayer,
    FinalForm,
    platformId,
    styles,
})(Component);
